import React, { useMemo, useState } from 'react';
import debounce from 'lodash/debounce';
import sumBy from 'lodash/sumBy';
import useResizeObserver, {
  ObservedSize
} from '@/helpers/custom-hooks/useResizeObserver';

const DEFAULT_ELEMENT_SYMBOL_WIDTH = 6;
const DEFAULT_ELEMENT_PADDING = 16;
const DEFAULT_ELEMENT_SYMBOL_GAP = 5;

interface Config {
  elementPadding?: number;
  elementSymbolGap?: number;
  elementSymbolWidth?: number;
}

export const getElementWidth = (elementText: string, config?: Config) => {
  const {
    elementPadding = DEFAULT_ELEMENT_PADDING,
    elementSymbolGap = DEFAULT_ELEMENT_SYMBOL_GAP,
    elementSymbolWidth = DEFAULT_ELEMENT_SYMBOL_WIDTH
  } = config || {};
  return (
    elementPadding + elementSymbolGap + elementSymbolWidth * elementText.length
  );
};

const useShowRemainingContent = (
  contentList: string[],
  config?: Config
): {
  containerRef: React.RefCallback<Element>;
  shouldShowRemainingContent: boolean;
} => {
  const [{ width: containerWidth = 100 }, setSize] = useState<ObservedSize>(
    {} as ObservedSize
  );

  const onResize = useMemo(() => debounce(setSize, 100, { leading: true }), []);
  const { ref: containerRef } = useResizeObserver({ onResize });

  const totalElementsListWidth = sumBy(contentList, element =>
    getElementWidth(element, config)
  );

  const shouldShowRemainingContent = useMemo(
    () => totalElementsListWidth > containerWidth,
    [totalElementsListWidth, containerWidth]
  );

  return { containerRef, shouldShowRemainingContent };
};

export default useShowRemainingContent;
